import { useMemo, useState, useEffect, useRef } from 'react';
import { useThrottleEffect } from 'ahooks';
import { message, Tabs } from 'antd';
import { getIsMobile } from 'lowcode/common/getDevice';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { formatPointsByLocale } from 'lowcomp/plugins/member/utils';
import { getLang } from 'lowcomp/plugins/member/utils';
import { useEcoDispatch, useEcoStore } from 'lowcode/utils/context/ecocredits';
import { useRouter } from 'next/router';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { useDispatch, EcoState, useStore } from '../context';
import Coupon from '../Coupon2';
import lang from '../lang';
import NoteModal from '../ModalComp/NoteModal';
import BuyForm from './BuyForm';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { EFArrow } from '@/components/UI/svg/Search';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import { rewardRedeemCoupon } from '@/service';
// import { copyText } from '@/utils';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { createPortal } from 'react-dom';
import LoginFormModal from '@/components/LoginFormModal';

interface ModuleTab {
    key: keyof EcoState;
    label: string;
}

export interface RuleProps {
    title: string;
    subTitle: string;
    pathUrl: string;
    setShowPage: any;
    refershData: () => void;
    modal?: boolean;
    defauleActiveTab?: string;
    bgColor?: string;
    customColor: Record<string, string | undefined>;
    isEditStatus?: boolean;
    id?: string;
    customStyle?: Record<string, string>;
    loginType?: 'page' | 'modal';
}

const EcoCreditRules = ({
    title,
    subTitle,
    pathUrl,
    setShowPage,
    refershData,
    modal,
    defauleActiveTab = 'COUPONS_RULES',
    customColor,
    isEditStatus = false,
    id = '',
    customStyle,
    loginType = 'page',
}: Partial<RuleProps>) => {
    const { locale } = getLocal();
    const isMobile = getIsMobile();
    const router = useRouter();
    const dispatch = useDispatch();
    const dispatchEco = useEcoDispatch();

    const buyFormRef = useRef<any>(null);

    const [activeKey, setActiveKey] = useState(defauleActiveTab);
    const [isLogin, setIsLogin] = useState(false);
    const [reedingLoading, setReedingLoading] = useState(false);
    const [currNotes, setCurrNotes] = useState<any>(null);
    const [currRules, setCurrRules] = useState<any>(null);

    const [couponModalOpen, setCouponModalOpen] = useState(false);
    const [currCoupon, setCurrCoupon] = useState<any>({});

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const t = getLang(lang, locale);

    const ecoState = useEcoStore();
    const state = useStore();
    const { timezoneList } = useMemberTimeStore();

    const allTabs: ModuleTab[] = pathUrl
        ? [
              { key: 'COUPONS_RULES_URL', label: t('discount') },
              { key: 'FREE_PRODUCTS_RULES_URL', label: t('product_text') },
              { key: 'THIRD_COUPONS_RULES_URL', label: t('gift_card') },
          ]
        : [
              { key: 'COUPONS_RULES', label: t('discount') },
              { key: 'FREE_PRODUCTS_RULES', label: t('product_text') },
              { key: 'THIRD_COUPONS_RULES', label: t('gift_card') },
          ];

    const filterTabs = useMemo(() => {
        return allTabs?.filter((tab) => {
            return state[tab.key]?.length;
        });
    }, [state, allTabs]);

    const resetRewardRedeemRules = useMemo(() => {
        const activeList = state[activeKey as keyof EcoState];
        return activeList?.slice(0, modal ? activeList?.length : isMobile ? 4 : 8);
    }, [state, isMobile, activeKey]);

    const copyText = (text?: string) => {
        if (!text) return;

        if (navigator?.clipboard && window?.isSecureContext) {
            window.navigator.clipboard.writeText(text);
            message.success(t('site_account_profile_save_success'));
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    // message.error()
                }
                textArea.remove();
            });
            message.success(t('site_account_profile_save_success'));
        }
    };

    const openConfirmModal = async (rule: any) => {
        if (!isLogin) {
            signupCookie?.({
                sector_name: title || t('redeem_ecocredits_title'),
                entry_position: 6,
            });
            if (loginType === 'modal') {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: 'Redeem Your EcoCredits_REDEEM NOW',
                });
                // closeModal && closeModal();
                setShowLoginModal(true);
                return;
            }
            router.push(`/${locale}/login?redirect=${encodeURIComponent(`/${locale}/${router.asPath}#${id ? id : ''}`)}`);
            return;
        }
        setCurrRules(rule);
    };

    const viewAll1 = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_details',
            button_name: t('view_all') || 'view all',
        });
        setShowPage?.(`points_modal$${activeKey}`);
        // pathUrl ? setShowPage?.(`ecocredit_rules_next$${activeKey}`) : setShowPage?.(`points_modal$${activeKey}`);
    };

    const viewAll2 = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            button_name: t('view_all'),
            list_name: 'none',
        });
        setShowPage?.(`points_modal$${activeKey}`);
        // pathUrl ? setShowPage?.(`ecocredit_rules_next$${activeKey}`) : setShowPage?.(`points_modal$${activeKey}`);
    };

    const onConfirm = async () => {
        await onRedeem(currRules);
        setCurrRules(null);
    };

    const shopNow = (coupon: any) => {
        const { thirdUrl, ruleType, jumpUrl } = coupon;
        // 第三方
        if (ruleType === 'THIRD_COUPONS') {
            if (isMobile) {
                router.push(thirdUrl);
                return;
            }
            setTimeout(() => window.open(thirdUrl, '_blank'));
            return;
        }

        // 普通优惠券并且填了jumpUrl
        if (ruleType === 'COUPONS' && jumpUrl) {
            if (isMobile) {
                router.push(jumpUrl);
                return;
            }
            setTimeout(() => window.open(jumpUrl, '_blank'));
            return;
        }

        // 默认
        if (isMobile) {
            router.push(`https://${locale}.ecoflow.com`);
            return;
        }
        window.open(`https://${locale}.ecoflow.com`, '_blank');
    };

    const successBtnMap: any = {
        COUPONS: t('store'),
        THIRD_COUPONS: t('spend_now'),
    };

    const getShowBtn = (coupon: any) => {
        const { ruleType, thirdUrl } = coupon || {};

        if (ruleType === 'COUPONS') return true;

        if (ruleType === 'THIRD_COUPONS' && thirdUrl) return true;

        return false;
    };

    const onRedeem = async (rule: any) => {
        if (!isLogin) {
            signupCookie?.({
                sector_name: title ? title : t('redeem_ecocredits_title'),
                entry_position: 0,
            });
            if (loginType === 'modal') {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_join_login',
                    button_name: 'Redeem Your EcoCredits_REDEEM NOW',
                });
                setShowLoginModal(true);
                return;
            }
            router.push(`/${locale}/login?redirect=${encodeURIComponent(`/${locale}/${router.asPath}#${id ? id : ''}`)}`);
            return;
        }

        const { ruleId, version, ruleWebsite, ruleType } = rule;
        const ruleSiteVersion = ruleWebsite?.version;
        const params: any = { ruleId, ruleVersion: version, ruleSiteVersion };

        // 如果是campaign规则 加上campaignId
        if (rule?.campaignId) {
            params.campaignVersion = rule?.campaignVersion;
        }

        // 如果是实体产品 加上地址
        if (ruleType === 'FREE_PRODUCTS') {
            const address = await buyFormRef?.current?.getFormData();
            params.address = address;
        }
        if (reedingLoading) return;
        setReedingLoading(true);

        try {
            const res = (await rewardRedeemCoupon(params, locale)) || '';
            if (res?.code === '0') {
                const data = res?.data || {};
                setCouponModalOpen(true);
                setCurrCoupon({ ...rule, ...data });
                copyText(res?.data?.coupon || '');
                refershData && refershData();
                dispatch({
                    type: 'getCouponsRules',
                    payload: { t, locale, pathUrl: pathUrl, timezoneList },
                });
                dispatch({
                    type: 'getProductRules',
                    payload: { locale, pathUrl },
                });
                dispatch({
                    type: 'getThiredCouponRules',
                    payload: { locale, pathUrl },
                });
                return;
            }

            // 积分不足
            if (res?.code === '2418') {
                message.error(t('no_enough_points') || res?.message);
                return;
            }

            // 前端页面长时间不刷新，导致兑换规则落后后端版本
            if (res?.code === '2422') {
                message.error(t('stay_too_long') || res?.message);
                return;
            }

            // 兑换次数超出上限
            if (res?.code === '2423') {
                message.error(t('exceeded_counts') || res?.message);
                return;
            }

            // 前端页面长时间不刷新，导致优惠券规则超过截止时间
            if (res?.code === '2424') {
                message.error(t('stay_too_long') || res?.message);
                return;
            }

            // 库存不足
            if (res?.code === '2429') {
                message.error(t('no_stock_tip') || res?.message);
                return;
            }

            // 库存不足
            if (res?.code === '2426') {
                message.error(t('no_stock_tip') || res?.message);
                return;
            }

            // 不允许兑换 plus会员
            if (res?.code === '2475') {
                message.error(t('only_plus_member') || res?.message);
                setCurrRules(null);
                return;
            }

            // 不允许兑换 普通会员
            if (res?.code === '2476') {
                message.error(t('only_member') || res?.message);
                setCurrRules(null);
                return;
            }

            message.error(res?.message || t('network_error') || 'Network Error');
        } finally {
            setReedingLoading(false);
        }
    };

    useThrottleEffect(() => {
        setIsLogin(getIsLogin());

        if (!isEditStatus) {
            dispatch({
                type: 'checkBlackList',
                payload: { locale },
            });
        }

        if (!pathUrl) {
            dispatch({
                type: 'getCouponsRules',
                payload: { t, locale, pathUrl: '', timezoneList },
            });
            dispatch({
                type: 'getProductRules',
                payload: { locale, pathUrl: '' },
            });
            dispatch({
                type: 'getThiredCouponRules',
                payload: { locale, pathUrl: '' },
            });
        }
    }, [timezoneList]);

    useEffect(() => {
        // 配置化，根据pathurl参数变化
        dispatch({
            type: 'getCouponsRules',
            payload: { t, locale, pathUrl, timezoneList },
        });
        dispatch({
            type: 'getProductRules',
            payload: { locale, pathUrl },
        });
        dispatch({
            type: 'getThiredCouponRules',
            payload: { locale, pathUrl },
        });
    }, [pathUrl, timezoneList]);

    useThrottleEffect(() => {
        if (!filterTabs?.length) return;
        if (!isEditStatus && resetRewardRedeemRules?.length) return;
        setActiveKey(filterTabs[0].key);
    }, [filterTabs?.length, pathUrl]);

    useEffect(() => {
        const queryRewardUserInfo = async () => {
            dispatchEco({
                type: 'changeRewardUserInfo',
                payload: { locale },
            });
        };

        if (!ecoState.rewardUserInfo && !isEditStatus) {
            queryRewardUserInfo();
        }
    }, [ecoState]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    if (!filterTabs?.length) {
        // 编辑状态下没数据也返回title
        if (isEditStatus) {
            return (
                <div className={`${styled.ecocredit_rules} ${modal ? 'modal' : ''}`}>
                    {<div className="temp-member-product-scene-h-title credits-title">{title ? title : t('redeem_ecocredits_title')}</div>}
                    {subTitle && <div className="temp-member-product-scene-h-subTitle">{subTitle}</div>}
                </div>
            );
        }
        return <div></div>;
    }

    return (
        <div className={`${styled.ecocredit_rules} ${modal ? 'modal' : ''}`}>
            <style global jsx>
                {`
                    .ant-message {
                        z-index: 999999;
                        .ant-message-notice .ant-message-notice-content {
                            border-radius: 6px;
                            overflow: hidden;
                        }
                    }
                    .ant-modal-root {
                        z-index: 9999;
                    }
                `}
            </style>
            {<div className="temp-member-product-scene-h-title credits-title">{title ? title : t('redeem_ecocredits_title')}</div>}
            {subTitle && <div className="temp-member-product-scene-h-subTitle">{subTitle}</div>}
            <div className={`container-center ${!isLogin ? 'container-tab-center' : ''}`}>
                {filterTabs?.length > 1 && (
                    <Tabs activeKey={activeKey} className="rewards-tabs" onChange={setActiveKey} centered>
                        {filterTabs?.map((tab) => (
                            <Tabs.TabPane tab={tab.label} key={tab.key}></Tabs.TabPane>
                        ))}
                    </Tabs>
                )}
                <div className="credits-desc-container">
                    <span className="credits-desc">
                        {isLogin
                            ? t.rich('have_points', {
                                  code: (children?: string) => <i className="points">{children}</i>,
                                  points: formatPointsByLocale(ecoState.rewardUserInfo?.points, locale) || '0',
                              })
                            : ''}
                    </span>
                    <span style={{ display: modal ? 'none' : 'block' }} onClick={viewAll1} className="view-all">
                        <span className="viewall-text">{t('view_all')}</span>
                        <EFArrow />
                    </span>
                </div>
            </div>

            <div className="rule-content">
                <div className="rule-list-wrap">
                    <ul className="rule-list">
                        {resetRewardRedeemRules?.map((rule: any) => (
                            <Coupon
                                disabledBtn={
                                    state.inBlackList ||
                                    (isLogin && Number(rule?.points) > ecoState.rewardUserInfo?.points) ||
                                    (rule?.ruleType !== 'COUPONS' && rule?.stock === 0)
                                }
                                showstock={rule?.ruleType !== 'COUPONS' && rule?.stockPicEnable}
                                className="rule-item"
                                key={rule?.ruleId}
                                coupon={rule}
                                onViewsRules={setCurrNotes}
                                onReedem={openConfirmModal}
                                showCountDown
                                customColor={customColor}
                                hideAmount={!['COUPONS', 'GIFT_CARD']?.includes(rule?.ruleType)}
                            />
                        ))}
                    </ul>
                    <p style={{ display: modal ? 'none' : 'block' }} onClick={viewAll2} className="view-all-bottom">
                        <span className="viewall-text-bottom">{t('view_all')}</span>
                        <EFArrow />
                    </p>
                </div>
            </div>

            {/* 兑换成功弹框 */}
            <EfModal
                className={`${styled.efmodal} coupon`}
                open={couponModalOpen}
                visible={couponModalOpen}
                onCancel={() => setCouponModalOpen(false)}
                zIndex={1200}
            >
                <div className="content">
                    <Coupon
                        className="coupon-card"
                        coupon={currCoupon}
                        onViewsRules={setCurrNotes}
                        hideAmount={!['COUPONS', 'GIFT_CARD']?.includes(currCoupon?.ruleType)}
                        showJumpBtn={'THIRD_COUPONS' === currCoupon?.ruleType && currCoupon.useUrl}
                        hideBtn
                        hideNote
                        modal={true}
                    />
                    <p className="m-desc">{t('redeemed_succ')}</p>
                    {['FREE_PRODUCTS', 'THIRD_COUPONS']?.includes(currCoupon?.ruleType) ? (
                        <p className="m-third-desc">
                            {currCoupon?.ruleType === 'THIRD_COUPONS' && !['br', 'mx', 'ph'].includes(locale) && `${t('copy_desc_2')}, `}
                            {currCoupon?.ruleType === 'THIRD_COUPONS' && ['br', 'mx', 'ph'].includes(locale) && `${t('copy_desc_2')} `}
                            <br />
                            {t.rich('grab_success_text2', {
                                code: (children?: string) => (
                                    <i
                                        className="btn"
                                        onClick={() => {
                                            setCouponModalOpen(false);
                                            setShowPage('coupon_modal$1');
                                            setCurrCoupon(undefined);
                                        }}
                                    >
                                        {children}
                                    </i>
                                ),
                            })}
                        </p>
                    ) : (
                        <p className="m-desc end">{t('copy_desc')}</p>
                    )}

                    {getShowBtn(currCoupon) && (
                        <Button onClick={() => shopNow(currCoupon)} className="m-btn">
                            {successBtnMap[currCoupon?.ruleType] || t('store')}
                        </Button>
                    )}
                </div>
            </EfModal>

            {/* 兑换确认弹框 */}
            <EfModal
                className={`${styled.efmodal} coupon over-height`}
                open={!!currRules}
                visible={!!currRules}
                onCancel={() => setCurrRules(null)}
                zIndex={1200}
            >
                <div className="content">
                    <div className="prompt_icon">
                        <Coupon
                            className="coupon-card"
                            coupon={currRules}
                            hideAmount={!['COUPONS', 'GIFT_CARD']?.includes(currRules?.ruleType)}
                            hideBtn
                            hideNote
                            customColor={customColor}
                            customStyle={customStyle}
                            modal={true}
                        />
                    </div>
                    <div className="confirm-rule-content">
                        <h5 className="confirm-rule-title">{t('rules')}</h5>
                        <ul className="confirm-rule-list">
                            {currRules?.noteList?.map((note: string, index: number) => (
                                <li key={index} className="confirm-rule-item">
                                    {note}
                                </li>
                            ))}
                        </ul>
                    </div>
                    {currRules?.ruleType === 'FREE_PRODUCTS' && <BuyForm ref={buyFormRef} />}
                    <h5 className="m-prompt-title">{t('confirm_text')}</h5>
                    <Button loading={reedingLoading} onClick={onConfirm} className="m-btn">
                        {t('confirm_btn')}
                    </Button>
                </div>
            </EfModal>

            {/* 优惠券rules弹框 */}
            <NoteModal currNotes={currNotes} setCurrNotes={setCurrNotes} customColor={customColor} />

            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </div>
    );
};

export default EcoCreditRules;
